module.exports = __webpack_public_path__ + "img/fashion_37.279889dc.jpg";